<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="车辆ID：" prop="car_id">
                <el-input v-model="model.car_id"></el-input>
            </el-form-item>
            <el-form-item label="vehicle_id：" prop="vehicle_id">
                <el-input v-model="model.vehicle_id"></el-input>
            </el-form-item>
            <el-form-item label="报告类型：" prop="report_type">
                <el-input v-model="model.report_type"></el-input>
            </el-form-item>
            <el-form-item label="记录时间：" prop="create_time">
                <el-input v-model="model.create_time"></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="begin_time">
                <el-input v-model="model.begin_time"></el-input>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <el-input v-model="model.end_time"></el-input>
            </el-form-item>
            <el-form-item label="用时(秒)：" prop="duration">
                <el-input v-model="model.duration"></el-input>
            </el-form-item>
            <el-form-item label="起始经度：" prop="begin_lon">
                <el-input v-model="model.begin_lon"></el-input>
            </el-form-item>
            <el-form-item label="起始纬度：" prop="begin_lat">
                <el-input v-model="model.begin_lat"></el-input>
            </el-form-item>
            <el-form-item label="结束经度：" prop="end_lon">
                <el-input v-model="model.end_lon"></el-input>
            </el-form-item>
            <el-form-item label="结束纬度：" prop="end_lat">
                <el-input v-model="model.end_lat"></el-input>
            </el-form-item>
            <el-form-item label="起始电量：" prop="begin_soc">
                <el-input v-model="model.begin_soc"></el-input>
            </el-form-item>
            <el-form-item label="结束电量：" prop="end_soc">
                <el-input v-model="model.end_soc"></el-input>
            </el-form-item>
            <el-form-item label="开始里程数：" prop="begin_odometer">
                <el-input v-model="model.begin_odometer"></el-input>
            </el-form-item>
            <el-form-item label="结束里程数：" prop="end_odometer">
                <el-input v-model="model.end_odometer"></el-input>
            </el-form-item>
            <el-form-item label="开始剩余里程：" prop="begin_mileage">
                <el-input v-model="model.begin_mileage"></el-input>
            </el-form-item>
            <el-form-item label="结束剩余里程：" prop="end_mileage">
                <el-input v-model="model.end_mileage"></el-input>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in">
                <el-input v-model="model.charge_in"></el-input>
            </el-form-item>
            <el-form-item label="使用电量：" prop="charge_use">
                <el-input v-model="model.charge_use"></el-input>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed">
                <el-input v-model="model.avg_speed"></el-input>
            </el-form-item>
            <el-form-item label="平均功率：" prop="avg_power">
                <el-input v-model="model.avg_power"></el-input>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc">
                <el-input v-model="model.avg_enc"></el-input>
            </el-form-item>
            <el-form-item label="平均海拔：" prop="avg_atitude">
                <el-input v-model="model.avg_atitude"></el-input>
            </el-form-item>
            <el-form-item label="平均室内温度：" prop="avg_inside_temp">
                <el-input v-model="model.avg_inside_temp"></el-input>
            </el-form-item>
            <el-form-item label="平均室外温度：" prop="avg_outside_temp">
                <el-input v-model="model.avg_outside_temp"></el-input>
            </el-form-item>
            <el-form-item label="功率记录：" prop="power_list">
                <el-input v-model="model.power_list"></el-input>
            </el-form-item>
            <el-form-item label="坐标记录：" prop="lon_lat_list">
                <el-input v-model="model.lon_lat_list"></el-input>
            </el-form-item>
            <el-form-item label="充电速度记录：" prop="charge_speed_list">
                <el-input v-model="model.charge_speed_list"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carReportEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                car_id: '',
                vehicle_id: '',
                report_type: '',
                create_time: '',
                begin_time: '',
                end_time: '',
                duration: '',
                begin_lon: '',
                begin_lat: '',
                end_lon: '',
                end_lat: '',
                begin_soc: '',
                end_soc: '',
                begin_odometer: '',
                end_odometer: '',
                begin_mileage: '',
                end_mileage: '',
                charge_in: '',
                charge_use: '',
                avg_speed: '',
                avg_power: '',
                avg_enc: '',
                avg_atitude: '',
                avg_inside_temp: '',
                avg_outside_temp: '',
                power_list: '',
                lon_lat_list: '',
                charge_speed_list: '',
            },
            getObj:{
                url:'/api/admin/carreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/carreport/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>